module.exports = __webpack_public_path__ + "static/img/nested.c948fb38.svg";